import React from 'react';

import Currency from 'components/currency';
import type { TypographyProps } from 'components/ui';
import { CurrencyLineSkeleton } from 'pages/cart/currency-line-skeleton';
import { t } from 'state/intl/translations';
import { useUIContext } from 'state/ui';

import { Total, TotalLabel, TotalsRow, TotalsRowSpacing } from './styled';

type TextProps = TypographyProps;

export const TaxesRow: React.FC<React.PropsWithChildren<{
  taxCents: number;
  isLoading?: boolean;
  mb?: TotalsRowSpacing;
  mt?: TotalsRowSpacing;
  textProps?: TextProps;
}>> = ({ taxCents, isLoading, mb = '$0', mt = '$0', textProps }) => {
  const { formatCurrencyForLocale } = useUIContext();

  return (
    <TotalsRow
      mb={mb}
      mt={mt}
      accessible={!isLoading}
      accessibilityRole="text"
      focusable={!isLoading}
      accessibilityLabel={
        !isLoading ? `${t('tax')}: ${formatCurrencyForLocale(taxCents)}` : undefined
      }
    >
      {isLoading ? (
        <CurrencyLineSkeleton />
      ) : (
        <>
          <TotalLabel focusable={false} {...(textProps && { fontSize: 'md' })}>
            {t('tax')}
          </TotalLabel>
          <Total focusable={false}>
            <Currency focusable={false} textProps={textProps} amount={taxCents} testID="totalTax" />
          </Total>
        </>
      )}
    </TotalsRow>
  );
};
